import {
  EnumUserEntitlementAttributeColumnModelDeriveType,
  TagMetadata,
} from "@/api";
import { IAccount } from "@/types/api";
export const Form = {
  displayName: "displayName",
  description: "description",
  type: "type",
  account: "account",
  dataProduct: "dataProduct",
  isMultiValue: "isMultiValue",
  isSessionUser: "isSessionUser",
  required: "required",
  scope: "identityType",
};

export type AttributeCategory = "user" | "agent" | "asset";
export interface QualifiedName {
  fullyQualifiedName?: string;
  name?: string;
  id?: string;
  type?: string;
}

export enum EnumConfigType {
  "AZURE_AD" = "AZURE_AD",
  "DATA_SOURCE" = "DATA_SOURCE",
  "SAILPOINT" = "SAILPOINT",
}

export interface UsernameColumnOption {
  id: string;
  name: string;
  /** Form-only: the `DB.SCHEMA.TABLE` the column was picked from. The saved
   *  value is a bare column name, so this is what tells a stale mapping (from a
   *  previous source table) apart from a same-named column of the new one. */
  table?: string;
}

export interface FormValue {
  [key: string]: unknown;
  account: IAccount;
  dataProduct: TagMetadata[];
  accountId?: IAccount;
  connectionId?: string;
  connectType?: { id: string; configType: EnumConfigType };
  attributeLevelUdf?: unknown[];
  mapAttributes?: boolean;
  attributes: {
    id?: string;
    _column: {
      columnName: QualifiedName;
    };
    hasConnection?: boolean;
    derivedInputs?: Input[];
    mappedColumn?: { mappedColumn: QualifiedName }[];
    parentColumn?: { parentColumn: QualifiedName }[];
    deriveColumn?: { deriveColumn: QualifiedName }[];
    searchColumn?: { searchColumn: QualifiedName[] }[];
    workspace?: { workspace: { id: string; name: string } }[];
    isMultiValue: boolean;
    hasSearchColumn: boolean;
    isSessionUser: boolean;
    displayName: string;
    description: string;
    attributeGroupName: { name: string; id: string };
    type: { id: string; name: string };
    deriveType: EnumUserEntitlementAttributeColumnModelDeriveType;
    isVirtual: boolean;
    required: boolean;
    /** Virtual-only: the source-table column holding the user's identity,
     *  serialized as `usernameColumn` inside `configurationValue`. */
    usernameColumn?: UsernameColumnOption | null;
  }[];
}

export type InputIdEnum =
  | "deriveColumn"
  | "mappedColumn"
  | "parentColumn"
  | "workspace";

export interface CompositeAttribute {
  id: string;
  displayName: string;
  attributeOrder: number;
  inputType: string;
  displayOnUI: boolean;
  api: string;
}

export interface Input {
  id: InputIdEnum;
  displayName: string;
  description: string;
  attributeOrder: number;
  inputType: string;
  displayOnUI: boolean;
  multicolumn: boolean;
  multiSelect: boolean;
  api: string;
  concatenatingString: string;
  compositeAttributeList: CompositeAttribute[];
  showOnConfirm: boolean;
  showOnConfirmMessage: string;
  accountType: string[];
  valueType?: string;
  jsonKeys?: string[];
}

export interface DeriveType {
  displayName: string;
  description: string;
  derriveType: EnumUserEntitlementAttributeColumnModelDeriveType;
  disable: boolean;
  inputs: Input[];
}

export interface AzureAttribute {
  id: string;
  name: string;
  type: string;
  description: string;
  availableInPortal: boolean;
  usedInUserFlows: boolean;
  multiValue: boolean;
}

export type DeriveTypes = DeriveType[];
